module.exports = __webpack_public_path__ + "img/business13_E.23c52535.png";